module.exports = __webpack_public_path__ + "static/media/ml-schema.bdbf6480.png";